import { Client } from "./client";
import { PortfolioDocument } from "./portfolio-document";
import { SamplingPoint } from "./sampling-point";
import { User } from "./user";


export class Portfolio {
    constructor() {
    }

    Id: number;
    OffsiteLocationCode: string;
    HasInitialSiteVisit: boolean;


    StrategyRequestDate: Date;
    ClientName: string;

    ClientCode: string;
    EDICode: string;
    /**
     * Only for the view because of Domain shitness
     */
    Client: Client;
    //-----------------
    MainContactName: string;
    CreatedOn: Date;

    Diagnostician: string;
    AnalysisLab: string;
    QuotationCode: string;
    QuotationName: string;

    PartnerCode: string;

    SamplingPoint: SamplingPoint = new SamplingPoint();

    PortfolioDocuments: PortfolioDocument[] = [];

    AlternateContactList: User[] = [];

    static mapFromJSON(json): Portfolio {
        const p = new Portfolio;
        p.Id = json['id'];
        p.OffsiteLocationCode = json['offsiteLocationCode'];
        p.ClientName = json['clientName'];
        p.ClientCode = json['clientCode'];
        p.EDICode = json['ediCode'];
        p.MainContactName = json['mainContactName'];
        p.StrategyRequestDate = json['strategyRequestDate'];
        p.CreatedOn = json['createdOn'];

        p.Diagnostician = json['diagnostician'];
        p.AnalysisLab = json['analysisLab'];
        p.QuotationCode = json['quotationCode'];
        p.QuotationName = json['quotationName'];
        p.PartnerCode = json['partnerCode'];

        p.HasInitialSiteVisit = json['hasInitialSiteVisit'];

        if (json['portfolioDocuments']) {
            p.PortfolioDocuments = json['portfolioDocuments'].map(item => PortfolioDocument.mapFromJson(item));
        }

        if (json['alternateContacts']) {
            p.AlternateContactList = json['alternateContacts'].map(item => User.mapFromJSON(item));
        }

        // Because the server doesn't encapsulate the Sampling Point...
        if (json['samplingPoint']) {
            p.SamplingPoint = SamplingPoint.mapFromJSON(json['samplingPoint']);
        }

        return p;
    }
}
